import { WarningCircleIcon } from '@phosphor-icons/react'

import * as Styles from './styles'

const WarningCodeText = ({ code }) => {
  return (
    <Styles.WarningCodeText type="bodyMRegular">
      <WarningCircleIcon />
      {code}
    </Styles.WarningCodeText>
  )
}

export default WarningCodeText
